import { render, staticRenderFns } from "./banner-basic.vue?vue&type=template&id=245fb0cf&scoped=true&"
import script from "./banner-basic.vue?vue&type=script&lang=js&"
export * from "./banner-basic.vue?vue&type=script&lang=js&"
import style0 from "./banner-basic.vue?vue&type=style&index=0&id=245fb0cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245fb0cf",
  null
  
)

export default component.exports